export default __webpack_public_path__ + "b0ed106bbac566074ed6840e5278e700.png";